import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { DateRangeComponent } from './date.range.component';
import { B2BAngularMaterialModule } from '../angular.material/b2b.angular.material.module';
import { DateRangeDescriptionComponent } from './date.range.description.component';
import { MomentPipeModule } from '../../pipes/moment.pipe/moment.pipe.module';

@NgModule({
    declarations: [DateRangeComponent, DateRangeDescriptionComponent],
    exports: [DateRangeComponent, DateRangeDescriptionComponent],
    imports: [B2BAngularMaterialModule, BrowserModule, MomentPipeModule]
})
export class DateRangeModule { }


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/components/common/date.range/date.range.module.ts